import React, { useEffect } from 'react';
import { useCampaings } from "../../../application/campaings/hooks/useCampaings";
import ToolbarComponent from '../../ui/section';
import DynamicTable from '../../ui/table2';
import Loader from '../../ui/loader';
import { ModalConfirm } from '../../ui/modal2';
import FloatingButton from '../../ui/floatButton';
import CampaignForm from '../../ui/CampaignForm';

const CampaingsPage = (props) => {
    const { 
        columns, 
        campaings, 
        customElements, 
        isLoading, 
        removeModal, 
        setRemoveModal, 
        remove, 
        createOrUpdate,
        update,
        current, 
        setCurrent, 
        getAll,
        getById,
    } = useCampaings();

    useEffect(() => {
        const loadData = async () => {
            const id = props.match?.params?.id;
            if (id) {
                await getById(id);
            } else {
                await getAll();
            }
        };
        loadData();
    }, [props.match?.params?.id, getAll, getById]);

    const create = (body) => {
        createOrUpdate(body);
    };

    return (
        <>
            <ToolbarComponent label="Campañas" showBackButton={false}>

                <CampaignForm onSubmit={create} initialData={current} onUpdate={update}  onCancel={()=>{setCurrent(null)}} />
                <DynamicTable
                    headers={columns}
                    data={campaings}
                    customElements={customElements}
                    fullPage={true}
                    showLabel={false}
                    loaderComponent={<Loader text="Cargando datos" />}
                    isLoading={isLoading}
                />
            </ToolbarComponent>
            <ModalConfirm isOpen={removeModal} onClose={() => setRemoveModal(false)} onAccept={remove} />
        </>
    )
}

export default CampaingsPage;